module.exports = __webpack_public_path__ + "static/media/bg.0350e89d.jpg";